import "./index.scss";
import { DiscountSort, DiscountPriceRange } from "components/UI/molecules";

export const DiscountFilters = (props) => {
  return (
    <div className="discount-filters">
      <DiscountSort {...props} />
      <DiscountPriceRange {...props} />
    </div>
  );
};
